import React from "react";

const TestimonialsPage = () => {
    const testimonials = [
        { name: "Ada", text: "TeeChaa helped me pass my WAEC with flying colors!" },
        { name: "Emeka", text: "I scored 290 in JAMB thanks to the quizzes and past questions." },
        { name: "Zainab", text: "Very easy to use and motivating. I recommend it to everyone." }
    ];

    return (
        <section id="testimonials" className="py-20 bg-white">
            <div className="container mx-auto px-6 text-center">
                <h2 className="text-4xl font-bold text-[#2148C0] mb-8">Success Stories</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {testimonials.map((t, i) => (
                        <div key={i} className="bg-gray-50 p-6 rounded-lg shadow-md">
                            <p className="italic text-gray-700 mb-4">"{t.text}"</p>
                            <h3 className="font-semibold text-[#2148C0]">- {t.name}</h3>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TestimonialsPage;
